import type { PrimaryGoal, Proposal } from '@shared/types';
import { decodeEntities } from './entities';
import { money } from './format';

const GOAL_SHORT: Record<PrimaryGoal, string> = {
  brand_awareness: 'awareness',
  lead_generation: 'lead-gen',
  sales_conversion: 'sales',
  customer_retention: 'retention',
  market_expansion: 'expansion',
  product_launch: 'launch',
};

/**
 * The one line the approve-and-build card shows, read from the proposal
 * itself — never the agent's prose: "LC Heating & Air · LA lead-gen ·
 * $5,000/mo · 9 channels". Missing parts are left out, not guessed.
 */
export function briefSummaryLine(proposal: Proposal): string {
  const name = proposal.advertiser.name ? decodeEntities(proposal.advertiser.name.trim()) : null;
  const areas = proposal.geography.areas;
  const place = areas[0]?.label ? `${areas[0].label}${areas.length > 1 ? ` +${areas.length - 1}` : ''}` : null;
  const goal = proposal.objective.primaryGoal ? GOAL_SHORT[proposal.objective.primaryGoal] : null;
  const market = [place, goal].filter(Boolean).join(' ') || null;
  const monthly = money(proposal.budget.monthly);
  const channels = proposal.mediaPlan.channels.length;
  return [
    name,
    market,
    monthly ? `${monthly}/mo` : null,
    channels > 0 ? `${channels} channel${channels === 1 ? '' : 's'}` : null,
  ].filter(Boolean).join(' · ') || 'Ready to build';
}
